import { Controller } from "@hotwired/stimulus"
import { loadChoices } from "../utils/load_choices"

const searchSVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 9.50024L12 14.5002L17 9.50024H7Z" fill="currentColor"/>
  </svg>
`

export default class extends Controller {
  static targets = ["select"]
  static values = { customIcon: String, appendSvg: Boolean }

  async connect() {
    this.ChoicesConstructor = await loadChoices()
    if (!this.isConnected) return

    this.initializeChoices()
  }

  disconnect() {
    // Clean up Choices instances to avoid leaks on DOM re-renders
    this.selectTargets.forEach(selectTarget => {
      const inst = selectTarget._choicesInstance
      if (inst && typeof inst.destroy === "function") {
        try { inst.destroy() } catch (e) { /* noop */ }
      }
      delete selectTarget._choicesInstance
    })
  }

  shouldAppendSvg(target) {
    const appendSvgValue = target.getAttribute("data-stylized-select-append-svg-value")
    return appendSvgValue !== "false"
  }

  initializeChoices() {
    const Choices = this.ChoicesConstructor
    if (!Choices) return

    this.selectTargets.forEach(selectTarget => {
      const isBlogCustomForm = selectTarget.closest(".blog-custom-form") !== null
      const customIconSVG = selectTarget.getAttribute("data-custom-icon") || (this.hasCustomIconValue ? this.customIconValue : searchSVG)

      const isMerchantForm = selectTarget.closest(".stores-custom-form") !== null

      const instance = new Choices(selectTarget, {
        searchEnabled: !isBlogCustomForm && !isMerchantForm,
        itemSelectText: "",
        allowHTML: true
      })

      // Keep a reference for cleanup on disconnect
      selectTarget._choicesInstance = instance

      if (this.shouldAppendSvg(selectTarget)) {
        const wrapper = selectTarget.closest('.choices[data-type*="select-one"]')
        if (wrapper) {
          const svgWrapper = document.createElement("span")
          svgWrapper.classList.add("choices-custom-icon", "text-grey-600")
          svgWrapper.innerHTML = customIconSVG
          wrapper.appendChild(svgWrapper)
        }
      }
    })
  }
}
